import { render, staticRenderFns } from "./FancyAccordion.vue?vue&type=template&id=67d7542c&scoped=true"
import script from "./FancyAccordion.vue?vue&type=script&lang=js"
export * from "./FancyAccordion.vue?vue&type=script&lang=js"
import style0 from "./FancyAccordion.vue?vue&type=style&index=0&id=67d7542c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d7542c",
  null
  
)

export default component.exports